interface AudioSniffableVideo {
  audioTracks?: { length: number }
  mozHasAudio?: boolean
  webkitAudioDecodedByteCount?: number
}

export function videoHasAudioTrack(el: HTMLVideoElement | null): boolean {
  const media = el as unknown as AudioSniffableVideo | null
  return Boolean(
    media?.audioTracks?.length
    || media?.mozHasAudio
    || media?.webkitAudioDecodedByteCount,
  )
}
